module.exports = __webpack_public_path__ + "static/media/conversation.7a8b5374.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/card-images/conversation.png
// module id = 139
// module chunks = 0